import { isNil, isBase64 } from '~utils';
import { b64toFile } from '@/components/CaptureModule/capture.utils';
import { reScalingImgWithCanvas } from '@/components/Packages/Captures/capture.utils';
import { store } from '@/store';
import heic2any from 'heic2any';

export default {
	name: 'CaptureModuleMixin',
	props: {
		value: {
			type: Boolean,
			required: true,
			default: false
		}
	},
	computed: {
		isOpen: {
			get() {
				return this.value;
			},
			/**
			 * @param {Boolean} status
			 * @return {Emitter}
			 */
			set(status) {
				this.$emit('input', status);
			}
		}
	},
	methods: {
		/**
		 * @param {Array} images
		 * @param {Number} id
		 * @return {Array}
		 */
		async loopImages(images) {
			for (let i = 0; i < images.length; i++) {
				await this.saveImage(images[i]);
			}
		},

		/**
		 * @param {String} imgData
		 * @return {File}
		 */
		async saveImage(imgData) {
			if (!isBase64(imgData)) {
				this.capture.dispatch('pushImgToSavedList', imgData);
			} else {
				const base64Data = imgData.split(';base64,');
				const timestamp = Date.now();
				const filename = `file_${timestamp}`;
				let ext = 'jpg';
				let mimeType = 'image/jpg';
				let fileData = {};

				if (base64Data[0].startsWith('data:image/')) {
					ext = base64Data[0].replace('data:image/', '');
					mimeType = `image/${ext}`;
				}
				if (base64Data[0].startsWith('data:application/pdf')) {
					ext = 'pdf';
					mimeType = 'application/pdf';
				}

				if (base64Data[0].startsWith('data:application/octet-stream')) {
					// if HEIC convert to png
					const fileFromBlob = b64toFile(base64Data[1], `${filename}.HEIC`, 'application/octet-stream');
					try {
						const blobHeic = await heic2any({ blob: fileFromBlob, toType: 'image/png' });
						fileData = new File([blobHeic], `${filename}.png`, { type: 'image/png' });
					} catch (error) {
						fileData = await reScalingImgWithCanvas(fileFromBlob);
					}
				} else {
					// else provide good file data.
					fileData = b64toFile(base64Data[1], `${filename}.${ext}`, mimeType);
				}
				let formData = new FormData();
				console.log(fileData);
				formData.set('uploadimage', fileData);
				if (!isNil(this.parentType)) formData.append('parentType', this.parentType);
				if (!isNil(this.parentSubType)) formData.append('parentSubType', this.parentSubType);
				if (!isNil(this.parentId)) formData.append('parentId', this.parentId);

				const savedImg = await this.$axios.$post('upload', formData, {
					onUploadProgress: (pe) => console.log({ 'pe.loaded': pe.loaded }),
					headers: {
						Authorization: `Bearer ${store.state.token}`,
						'content-type': 'multipart/form-data'
					}
				});
				this.capture.dispatch('pushImgToSavedList', savedImg);
			}
		}
	}
};
